/**
 * BalanceSummarySection Component
 *
 * Section displaying 3 balance summary cards stacked vertically.
 * Used in the LEFT COLUMN of the Recursos Dashboard.
 *
 * Design specs from Figma:
 * - 3 cards STACKED VERTICALLY (not horizontal!)
 * - Gap between cards: 24px
 * - Each card: 718px width, 158px height
 * - All cards have same title: "Saldo do Balanço"
 *
 * Layout: Vertical flex stack in left column
 */

import { BalanceSummaryCard } from "./balance-summary-card";
import { ResourceBalanceSummary } from "@/types/recursos-dashboard.interface";

interface BalanceSummarySectionProps {
  /** Array of 3 balance summary data items */
  balanceSummary: ResourceBalanceSummary[];
}

export function BalanceSummarySection({
  balanceSummary,
}: BalanceSummarySectionProps) {
  return (
    <>
      {balanceSummary.map((card, index) => (
        <BalanceSummaryCard
          key={index}
          label={card.label}
          value={card.value}
          subtitle={card.subtitle}
          percentage={card.percentage}
          trend={card.trend}
        />
      ))}
    </>
  );
}
